import { useContext, useEffect, useState } from "react";
// import "./HomeSecretaria.scss";

import Sidebar from "../../../shared/components/sidebar/Sidebar";
import Navbar from "../../../shared/components/navbar/Navbar";

import DashboardIcon from "@mui/icons-material/Dashboard";
import { AuthContext } from "../../../shared/context/auth-context";
import { ClinicaContext } from "../../../shared/context/clinica-context";
import { useHttpClient } from "../../../shared/hooks/http-hook";
import DashboardAdministrativoFinanceiro from "./components/DashboardAdministrativoFinanceiro";
import DashboardAdministrativoTopCategorias from "./components/DashboardAdministrativoTopCategorias";
import DashboardAdministrativoProdutividadeFinanceira from "./components/DashboardAdministrativoProdutividadeFinanceira";
import { useLoading } from "../../../shared/context/LoadingContext";
import "./HomeAdministrativo.scss";
import StockControllAdministrativo from "./components/StockControllAdministrativo";
import "../../../shared/css/Checkbox.scss";

const DAILY_MESSAGES = [
  "Que o telefone toque só com boas notícias e pacientes simpáticos!",
  "Hoje o café é teu aliado e o sistema, teu campo de batalha!",
  "Organizar agenda é arte — e tu és o Picasso do Excel!",
  "Que o dia comece calmo e termine com tudo confirmado!",
  "Se o sistema travar, respira: nem o computador entende o stress da receção!",
  "Hoje é dia de transformar confusão em coordenação!",
  "Que tua paciência dure mais que fila de espera!",
  "O segredo do sucesso? Um sorriso na receção e um café por perto!",
  "Lembra: a primeira impressão do paciente é sempre o teu sorriso!",
  "Hoje a meta é simples: agendar tudo, perder nada e manter a calma!",
  "Que o Wi-Fi coopere e o paciente não esqueça o horário!",
  "Gerir clínica é fácil — disse ninguém nunca!",
  "Hoje o foco é brilhar: nos emails, nos atendimentos e no humor!",
  "Que cada ligação traga boas notícias e nenhum cancelamento!",
  "Organização é teu superpoder — e o caos, teu inimigo natural!",
  "Hoje és o maestro da clínica — e todos tocam conforme tua agenda!",
  "Que os lembretes cheguem antes dos atrasos!",
  "Nada é impossível quando há planilha, paciência e café!",
  "Hoje é o dia de mostrar que bom atendimento também cura!",
  "Que teu dia seja mais leve que a caixa de entrada!",
  "Se o plano de saúde complicar, sorri: é só mais uma terça-feira!",
  "Que tua gestão inspire e teu humor contagie!",
  "Hoje és o escudo contra o caos — e o caos respeita sorriso firme!",
  "Que o dia renda tanto quanto mês com feriado e bônus!",
  "Nada como começar o dia sabendo que sem ti, nada anda!",
  "Que tua voz no telefone soe tão doce quanto confirmação de consulta!",
  "Hoje o mundo pode girar, mas a receção não pode parar!",
  "Lembra: secretária boa não se estressa — sincroniza com o universo!",
  "Que teu dia seja tão eficiente quanto teu olhar quando alguém bagunça a agenda!",
  "Organizar pessoas é difícil, mas tu fazes parecer fácil!",
  "Hoje é dia de sorrir, resolver e brilhar — tudo ao mesmo tempo!",
  "Hoje lembra: o segredo da boa gestão é café quente e paciência gelada!",
];

function HomeAdministrativo() {
  const { startLoading, stopLoading } = useLoading();

  const [contasCorrentes, setContasCorrentes] = useState();
  const [despesas, setDespesas] = useState();
  const [categoriasFinanceiro, setCategoriasFinanceiro] = useState();
  const [stock, setStock] = useState();
  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);
  const { sendRequest } = useHttpClient();
  ///////////////////////////////////////////////////
  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        const [
          contasCorrentesResponse,
          despesasResponse,
          categoriasResponse,
          stockResponse,
        ] = await Promise.all([
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/dashadministrativo/${clinica.clinica._id}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token }
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/despesas/clinica/${clinica.clinica._id}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token }
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/categoriasfinanceiro/clinica/${clinica.clinica._id}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token }
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/stocks/clinica/getProdutosStockAEsgotar/${clinica.clinica._id}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token }
          ),
        ]);

        setContasCorrentes(contasCorrentesResponse.contasCorrentes);
        setDespesas(despesasResponse.despesas);
        setCategoriasFinanceiro(categoriasResponse.categoriasFinanceiro);
        setStock(stockResponse.stock);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };

    fetchData();
  }, [sendRequest, auth.token, clinica.clinica._id]);

  return (
    <div className="home">
      <Sidebar />
      <div className="homeContainer">
        <Navbar title="Dashboard" icon={DashboardIcon} />
        <div className="dashboard__ola">
          <span className="dashboard__ola__big">{`Olá, ${auth.nomeAbreviado}!`}</span>
          <span className="dashboard__ola__small">
            {DAILY_MESSAGES[new Date().getDate() - 1] || ""}
          </span>
        </div>
        {contasCorrentes && despesas && categoriasFinanceiro && (
          <div className="homeContainerAdministrativo">
            <div className="homeAdministrativo__topContainer">
              <DashboardAdministrativoFinanceiro
                cCorrentes={contasCorrentes}
                desp={despesas}
              />
              <DashboardAdministrativoTopCategorias
                desp={despesas}
                catF={categoriasFinanceiro}
              />
            </div>
            <div className="homeAdministrativo__bottomContainer">
              <DashboardAdministrativoProdutividadeFinanceira
                desp={despesas}
                cCorrentes={contasCorrentes}
              />
              <StockControllAdministrativo stock={stock} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default HomeAdministrativo;
